import { MemberStatus, TableNames, URLS } from '~/constants';
import { membersStore } from '~/stores/MembersStore';
import { organizationChartStore } from '~/stores/OrganizationChartStore';
import environment from '~/stores/providers/environment';
import idb from '~/stores/providers/Idb';
import { userStore } from '~/stores/UserStore';
import { mMaybe } from '~/utils/monadUtil';
import { isEmpty } from 'lodash';
import { computed } from 'mobx';
import chain from 'ramda/es/chain';
import ifElse from 'ramda/es/ifElse';
import juxt from 'ramda/es/juxt';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import { Maybe } from 'ramda-fantasy';

import Actions from '../Actions';

class UserActions {
  constructor(private actions: Actions) {}

  private get userId() {
    return userStore.id;
  }

  @computed({ keepAlive: true })
  get departmentName(): string {
    return pipe<any, any, any, any>(
      ifElse(isEmpty, Maybe.Nothing, Maybe.Just),
      chain(organizationChartStore.getDepartmentById),
      mMaybe(this.user.department, prop('name'))
    )(this.user.departmentId);
  }

  @computed({ keepAlive: true })
  get user() {
    return membersStore.getById(userStore.id);
  }

  logout = () => {
    if (environment.isWinNative()) {
      this.actions.nativeActions.sendLogout({ isSessionOut: false });
    } else {
      window.location.href = URLS.SIGN_OUT;
    }
  };

  public updateStatusFromNative = (status: MemberStatus) => {
    juxt([
      this.actions.proxyActions.updateMeStatus,
      // 일렉트론에서 상태변경 요청이 오면 바로 FE에도 반영
      this.updateLocalStatus,
    ])(status);
  };

  updateLocalStatus = (status: MemberStatus) => {
    membersStore.updateStatus({
      id: userStore.id,
      status,
    });
    if (status !== MemberStatus.AutoAway) {
      this.updateIdbLocalStatus(status);
    }
  };

  getLocalStatus = () => {
    return idb.get(TableNames.Settings, `status:${this.userId}`);
  };

  updateIdbLocalStatus = (status: MemberStatus) => {
    return idb.put(TableNames.Settings, `status:${this.userId}`, status);
  };
}

export default UserActions;
